import EntityBaseRepository from '@/api/misc/EntityBaseRepository';
import { AxiosResponse } from 'axios';

export interface ActivityLogFilters {
    page?: number,
    pageSize?: number,
    action?: string,
    operation?: string,
    entityType?: string,
    actorId?: string,
    success?: boolean,
    from?: string,
    to?: string,
    changesOnly?: boolean
}

/**
 * Repository for the admin activity-log read endpoints (backend `activityLog`
 * service). Read-only by design: rows are written exclusively by the backend
 * middleware, so there is no client-side write path.
 */
export default class ActivityLogRepository extends EntityBaseRepository {
    public list(filters: ActivityLogFilters = {}): Promise<AxiosResponse> {
        const params = new URLSearchParams();
        Object.entries(filters).forEach(([key, value]) => {
            if (value !== undefined && value !== null && value !== '') {
                params.append(key, String(value));
            }
        });
        const query = params.toString();
        return this.axiosClient.get(`activity-log${query ? `?${query}` : ''}`);
    }

    /** Distinct actors that appear in the log, for the actor filter. */
    public listActors(): Promise<AxiosResponse> {
        return this.axiosClient.get('activity-log/actors');
    }
}
